import { Link, useLocation } from "react-router-dom";
import Navbar from "../components/feature/Navbar";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-brand-black flex flex-col">
      <Navbar />
      <div className="flex-1 flex flex-col items-center justify-center text-center px-6 relative overflow-hidden">
        <div className="absolute inset-0 pointer-events-none">
          <span
            className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 font-display font-black text-gold/5 select-none"
            style={{ fontSize: "clamp(8rem, 30vw, 28rem)", whiteSpace: "nowrap" }}
          >
            404
          </span>
        </div>
        <div className="relative z-10">
          <span className="text-gold text-xs font-sans font-semibold tracking-[0.3em] uppercase block mb-6">
            Page Not Found
          </span>
          <h1 className="font-display font-black text-white text-5xl md:text-6xl mb-4">
            Oops! Off the{" "}
            <span className="text-gradient-gold">Grid</span>
          </h1>
          <p className="text-white/50 font-sans text-base mb-3">
            The page{" "}
            <code className="text-gold font-mono text-sm bg-gold/10 px-2 py-0.5 rounded">
              {location.pathname}
            </code>{" "}
            doesn&apos;t exist.
          </p>
          <p className="text-white/40 font-sans text-sm mb-10">
            Let&apos;s get you back to where the action is.
          </p>
          <Link
            to="/"
            className="btn-gold inline-flex items-center gap-2 px-8 py-4 rounded-full text-white font-sans font-semibold text-sm tracking-widest cursor-pointer whitespace-nowrap"
          >
            <i className="ri-home-line" />
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}
